//
//  SDKTextDecoration.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var TextDecoration;
(function (TextDecoration) {
    TextDecoration["original"] = "None";
    TextDecoration["underline"] = "Underline";
    TextDecoration["strikethrough"] = "Strikethrough";
})(TextDecoration || (TextDecoration = {}));
